import React from 'react';

import CatalogPageContent from 'components/dashboard/catalog-content/CatalogPageContent';

const DashboardCatalogPage = () => <CatalogPageContent />;

export default DashboardCatalogPage;
